import { useCallback, useEffect, useState } from "react";
import Loading from "../../../../components/Loading";
import NewFilterContainer from "../../../../components/NewFilterContainer ";
import FilterMenu from "../../../../components/FilterMenu";
import MainPageContainer from "../../../../components/MainPageContainer";
import SecondaryHeader from "../../../Rajasthan/Demand/SecondaryHeader";
import { useSelector } from "react-redux";
import {
  getBuyerSellersData,
  getBuyerSellersTrendData,
  getAvailableEntities,
} from "../../../../Rest_api/RestApi";
import { SearchBox } from "../../../../components/Search";
import { DemoFilterData } from "../../../../store/state/UtilizationData";
import {
  ChartDataParams,
  FormatChartData,
} from "../../../../components/recharts/functions";
import { ReMixChart } from "../../../../components/recharts/ReMixCharts";
import { BrushStart, ChartType } from "../../../../models/chart_model";
import { GripVertical } from "lucide-react";
import BuyerSellerChart from "./TopBuyersSellersPopup";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";

const exchanges = ["IEX", "PXIL", "HPX"];
const products = ["DAM", "RTM", "GDAM", "HPDAM"];
const regions = ["WRLDC", "ERLDC", "NRLDC", "SRLDC", "NERLDC"];
const type = ["Buyers & Sellers", "Regions", "Trends"];

const formatDateToDDMMYYYY = (date: Date) => {
  return date.toLocaleDateString("en-GB").replace(/\//g, "-");
};

const BuyersAndSellers = () => {
  const [loading, setLoading] = useState(false);
  const [selectedExchanges, setSelectedExchanges] = useState<string[]>([
    exchanges[0],
  ]);
  const [selectedTypes, setSelectedTypes] = useState<string>(type[0]);
  const [selectedProducts, setSelectedProducts] = useState<string[]>([
    products[0],
  ]);
  const activeTab = useSelector((state: any) => state.switchTabs.activeTab);
  const DefaultDates = useSelector(
    (state: any) => state.defaultDatesSetter.defaultDates
  );
  const [data, setData] = useState<{
    region_buyer: any[];
    region_seller: any[];
    buyer: any[];
    seller: any[];
  }>({ region_buyer: [], region_seller: [], buyer: [], seller: [] });
  const [selectedRegion, setSelectedRegion] = useState<string[]>([
    regions[0],
    regions[1],
    regions[2],
    regions[3],
    regions[4],
  ]);

  const _handlefetchData = useCallback(async () => {
    if (DefaultDates[activeTab].defaultRangeDate === undefined) {
      return;
    }
    setLoading(true);
    const dates = DefaultDates[activeTab].defaultRangeDate;
    const startDateStr = formatDateToDDMMYYYY(dates.startDate);
    const endDateStr = formatDateToDDMMYYYY(dates.endDate);
    const formData = new FormData();
    formData.append("start_date", startDateStr);
    formData.append("end_date", endDateStr);
    formData.append("exchange", selectedExchanges.join(","));
    formData.append("product", selectedProducts.join(","));
    formData.append("region", selectedRegion.join(","));
    const data = await getBuyerSellersData(formData);
    setData(data || {});
    setLoading(false);
  }, [
    DefaultDates,
    activeTab,
    selectedExchanges,
    selectedProducts,
    selectedRegion,
  ]);

  useEffect(() => {
    _handlefetchData();
  }, [_handlefetchData]);

  return (
    <div className="gas-page-container">
      {loading && <Loading />}
      <NewFilterContainer>
        <div className="side-filters-container text-nowrap">
          <FilterMenu
            title="Group By"
            items={type.map((item) => item)}
            selectedItems={[selectedTypes]}
            onSelect={(item, index) => {
              setSelectedTypes(type[index]);
            }}
          />
          <FilterMenu
            title="Exchanges"
            items={exchanges.map((item) => item)}
            selectedItems={selectedExchanges}
            setSelectedItems={setSelectedExchanges}
          />
          <FilterMenu
            title="Products"
            items={products.map((item) => item)}
            selectedItems={selectedProducts}
            setSelectedItems={setSelectedProducts}
          />

          <FilterMenu
            title="Regions"
            items={regions.map((item) => item)}
            selectedItems={selectedRegion}
            setSelectedItems={setSelectedRegion}
          />
        </div>
      </NewFilterContainer>

      <MainPageContainer>
        <SecondaryHeader showViewMode={false} />
        <div className="gas-chart-container">
          {/* <div className="gas-heading gap-x-10">
            <h2 className="chartHeading w-60">Buyers & Sellers</h2>
          </div> */}

          <div
            style={{ height: "calc(100vh - 200px)" }}
          // className="grid grid-cols-1 lg:grid-cols-2 gap-6 "
          >
            {selectedTypes === "Buyers & Sellers" && (
              <>
                <BuyerSellerChartTab data={data} />
              </>
            )}

            {selectedTypes === "Regions" && (
              <>
                <RegionTab data={data} />
              </>
            )}

            {selectedTypes === "Trends" && (
              <>
                <TrendsTab
                  selectedExchanges={selectedExchanges}
                  selectedProducts={selectedProducts}
                  selectedRegion={selectedRegion}
                />
              </>
            )}
          </div>
        </div>
        <div className="gna-footer-container">
          <div className="grid grid-cols-2 justify-between gap-5 ">
            <p className="gna-footer-text col-span-1">
              Powered by <strong>GNA Energy</strong>
            </p>
            <strong className="gna-footer-text col-span-1 text-end">
              Beta Version
            </strong>
          </div>
        </div>
      </MainPageContainer>
    </div>
  );
};

export default BuyersAndSellers;

function BuyerSellerChartTab({ data }: { data: any }) {
  return (
    <>
      <PanelGroup className="" direction="horizontal">
        <Panel defaultSize={50} minSize={30} maxSize={70}>
          {/* Buyers Section */}
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
            {/* Header */}
            <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full bg-gray-800"></div>
                  <h4 className="text-base font-semibold text-gray-800">
                    Top Buyers
                  </h4>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700 bg-gray-200 px-3 py-1 rounded-full">
                  <svg
                    className="w-4 h-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
                  </svg>
                  {data.buyer?.filter((b: { value: number }) => b.value > 0)
                    .length || 0}{" "}
                  Active
                </div>
              </div>

              {/* Total Volume */}
              <div className="mt-3 ps-6">
                <div className="text-sm text-gray-600 font-medium">
                  Total Volume
                </div>
                <div className="text-lg font-bold text-gray-800">
                  {data.buyer
                    ?.reduce(
                      (sum: any, item: { value: any }) => sum + item.value,
                      0
                    )
                    .toFixed(2)}{" "}
                  MWh
                </div>
              </div>
            </div>

            {/* Chart Content */}
            <div className="p-4 h-[calc(100vh-340px)] overflow-x-hidden overflow-y-auto">
              <BuyerSellerChart
                data={data.buyer || []}
                showLegend={false}
                type="buyer"
                theme="light"
              />
            </div>
          </div>
        </Panel>
        <PanelResizeHandle className="w-[1px] mx-5 bg-gray-200 h-[80%] my-auto relative">
          <div className="bg-white py-2 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <GripVertical color="#CDCDD3" />
          </div>
        </PanelResizeHandle>
        <Panel defaultSize={50} minSize={30} maxSize={70}>
          {/* Sellers Section */}
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
            {/* Header */}
            <div className="bg-[#34656D] px-6 py-4 border-b ">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full bg-white"></div>
                  <h4 className="text-base font-semibold text-white">
                    Top Sellers
                  </h4>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-300 bg-gray-700 px-3 py-1 rounded-full">
                  <svg
                    className="w-4 h-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  {data.seller?.filter((s: { value: number }) => s.value > 0)
                    .length || 0}{" "}
                  Active
                </div>
              </div>

              {/* Total Volume */}
              <div className="mt-3 ps-6">
                <div className="text-sm text-gray-300 font-medium">
                  Total Volume
                </div>
                <div className="text-lg font-bold text-white">
                  {data.seller
                    ?.reduce(
                      (sum: any, item: { value: any }) => sum + item.value,
                      0
                    )
                    .toFixed(2)}{" "}
                  MWh
                </div>
              </div>
            </div>

            {/* Chart Content */}
            <div className="p-4 h-[calc(100vh-340px)] overflow-x-hidden overflow-y-auto">
              <BuyerSellerChart
                data={data.seller || []}
                showLegend={false}
                type="seller"
                theme="light"
              />
            </div>
          </div>
        </Panel>
      </PanelGroup>
    </>
  );
}

function RegionTab({ data }: { data: any }) {
  return (
    <>
      <PanelGroup className="" direction="horizontal">
        <Panel defaultSize={50} minSize={30} maxSize={70}>
          {/* Buyers Section */}
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
            {/* Header */}
            <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full bg-gray-800"></div>
                  <h4 className="text-base font-semibold text-gray-800">
                    Buyers By Region
                  </h4>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700 bg-gray-200 px-3 py-1 rounded-full">
                  <svg
                    className="w-4 h-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
                  </svg>
                  {data.region_buyer?.filter(
                    (b: { value: number }) => b.value > 0
                  ).length || 0}{" "}
                  Active
                </div>
              </div>

              {/* Total Volume */}
              <div className="mt-3 ps-6">
                <div className="text-sm text-gray-600 font-medium">
                  Total Volume
                </div>
                <div className="text-lg font-bold text-gray-800">
                  {data.buyer
                    ?.reduce(
                      (sum: any, item: { value: any }) => sum + item.value,
                      0
                    )
                    .toFixed(2)}{" "}
                  MWh
                </div>
              </div>
            </div>

            {/* Chart Content */}
            <div className="p-4 h-[calc(100vh-340px)] overflow-x-hidden overflow-y-auto">
              <BuyerSellerChart
                data={data.region_buyer || []}
                showLegend={false}
                type="buyer"
                theme="light"
              />
            </div>
          </div>
        </Panel>
        <PanelResizeHandle className="w-[1px] mx-5 bg-gray-200 h-[80%] my-auto relative">
          <div className="bg-white py-2 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <GripVertical color="#CDCDD3" />
          </div>
        </PanelResizeHandle>
        <Panel defaultSize={50} minSize={30} maxSize={80}>
          {/* Sellers Section */}
          <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
            {/* Header */}
            <div className="bg-[#34656D] px-6 py-4 border-b ">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full bg-white"></div>
                  <h4 className="text-base font-semibold text-white">
                    Sellers By Region
                  </h4>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-300 bg-gray-700 px-3 py-1 rounded-full">
                  <svg
                    className="w-4 h-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  {data.region_seller?.filter(
                    (s: { value: number }) => s.value > 0
                  ).length || 0}{" "}
                  Active
                </div>
              </div>

              {/* Total Volume */}
              <div className="mt-3 ps-6">
                <div className="text-sm text-gray-300 font-medium">
                  Total Volume
                </div>
                <div className="text-lg font-bold text-white">
                  {data.region_seller
                    ?.reduce(
                      (sum: any, item: { value: any }) => sum + item.value,
                      0
                    )
                    .toFixed(2)}{" "}
                  MWh
                </div>
              </div>
            </div>

            {/* Chart Content */}
            <div className="p-4 h-[calc(100vh-340px)] overflow-x-hidden overflow-y-auto">
              <BuyerSellerChart
                data={data.region_seller || []}
                showLegend={false}
                type="seller"
                theme="light"
              />
            </div>
          </div>
        </Panel>
      </PanelGroup>
    </>
  );
}

function TrendsTab({
  selectedExchanges,
  selectedProducts,
  selectedRegion,
}: any) {
  const activeTab = useSelector((state: any) => state.switchTabs.activeTab);
  const DefaultDates = useSelector(
    (state: any) => state.defaultDatesSetter.defaultDates
  );
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [chartBuyerData, setChartBuyerData] = useState<any[]>([]);
  const [chartSellerData, setChartSellerData] = useState<any[]>([]);
  const [chartBuyerKeys, setChartBuyerKeys] = useState<string[]>([]);
  const [chartSellerKeys, setChartSellerKeys] = useState<string[]>([]);
  const [selectedBuyers, setSelectedBuyers] = useState<any[]>([]);
  const [selectedSellers, setSelectedSellers] = useState<any[]>([]);
  const [availableEntities, setAvailableEntities] = useState<any[]>([]);

  useEffect(() => {
    const fetchEntities = async () => {
      if (DefaultDates[activeTab]?.defaultRangeDate) {
        setLoading(true);
        const dates = DefaultDates[activeTab].defaultRangeDate;
        const startDateStr = dates.startDate.toISOString().split('T')[0];
        const endDateStr = dates.endDate.toISOString().split('T')[0];
        try {
          const entities = await getAvailableEntities({
            start_date: startDateStr,
            end_date: endDateStr
          });
          const options = entities.map((e: any) => ({ label: e.name, value: e.name }));
          setAvailableEntities(options);

          // Default select specific entities requested by user
          if (selectedBuyers.length === 0 && selectedSellers.length === 0 && options.length > 0) {
            const defaultBuyersNames = ["TELANGANA STATE", "GEB STATE", "WBSETCL"];
            const defaultSellersNames = ["ODISHA STATE", "TAMILNADU STATE", "JPL2"];

            const buyers = options.filter((o: any) => defaultBuyersNames.includes(o.value));
            const sellers = options.filter((o: any) => defaultSellersNames.includes(o.value));

            // If some specific entities are not found, we could fallback or just set what we found
            setSelectedBuyers(buyers);
            setSelectedSellers(sellers);
          }
        } catch (error) {
          console.error("Error fetching entities:", error);
        }
        setLoading(false);
      }
    };
    fetchEntities();
  }, [DefaultDates, activeTab]);

  function FormatBuyerSellerData(data: any) {
    if (!data || !data.buyer || !data.seller) {
      return [];
    }
    const transformedData: any[] = [];

    const targetKeys = ["buyer", "seller"];

    targetKeys.forEach((key) => {
      if (data[key] && Array.isArray(data[key])) {
        data[key].forEach((item: any) => {
          // Find MCP from the payload's mcp array
          const mcpForDate = data.mcp?.find(
            (mcp: any) => mcp.date === item.name
          );

          transformedData.push({
            ...item,
            type: key,
            mcp: mcpForDate?.wt_mcp || null,
            date: item.name,
          });
        });
      }
    });

    return transformedData;
  }

  const _handlefetchData = useCallback(async () => {
    if (DefaultDates[activeTab].defaultRangeDate === undefined) {
      return;
    }
    setLoading(true);
    const dates = DefaultDates[activeTab].defaultRangeDate;
    const startDateStr = formatDateToDDMMYYYY(dates.startDate);
    const endDateStr = formatDateToDDMMYYYY(dates.endDate);
    const buyers = selectedBuyers.map((b: any) => b.value);
    const sellers = selectedSellers.map((s: any) => s.value);
    const formData = new FormData();
    formData.append("start_date", startDateStr);
    formData.append("end_date", endDateStr);
    formData.append("exchange", selectedExchanges.join(","));
    formData.append("product", selectedProducts.join(","));
    formData.append("region", selectedRegion.join(","));
    formData.append("sellers", sellers.join(","));
    formData.append("buyers", buyers.join(","));
    const data = await getBuyerSellersTrendData(formData);
    setData(FormatBuyerSellerData(data));
    setLoading(false);
  }, [
    DefaultDates,
    activeTab,
    selectedBuyers,
    selectedExchanges,
    selectedProducts,
    selectedRegion,
    selectedSellers,
  ]);

  useEffect(() => {
    _handlefetchData();
  }, [_handlefetchData]);

  useEffect(() => {
    let filteredData = data.filter((item: any) => item.type === "buyer");

    const par: ChartDataParams = {
      keys: ["date", "mcp"].concat(selectedBuyers.map((b: any) => b.value)),
      groupBy: [],
      volumeKey: ``,
      aggregationKeys: [],
      averageKeys: [],
      averageDuplicationKeys: [],
      priceKey: "",
      data: filteredData,
    };
    const cData = FormatChartData(par);
    setChartBuyerData(cData.data);
    setChartBuyerKeys(cData.keys);
  }, [data, selectedBuyers]);

  useEffect(() => {
    let filteredData = data.filter((item: any) => item.type === "seller");

    const par: ChartDataParams = {
      keys: ["date", "mcp"].concat(selectedSellers.map((s: any) => s.value)),
      groupBy: [],
      volumeKey: ``,
      aggregationKeys: [],
      averageKeys: [],
      averageDuplicationKeys: [],
      priceKey: "",
      data: filteredData,
    };
    const cData = FormatChartData(par);
    setChartSellerData(cData.data);
    setChartSellerKeys(cData.keys);
  }, [data, selectedBuyers, selectedSellers]);

  const createChartObject = (key: string, index: number, buyer: any) => {
    return {
      dataKey: `${buyer.value}`,
      name: `${buyer.label}`,
      unit: "MWh",
    };
  };

  function getBuyersLegends() {
    return selectedBuyers
      .flatMap((buyer: any, index: number) =>
        chartBuyerKeys.map(
          (key, chartIndex) => createChartObject(key, chartIndex, buyer) as any
        )
      )
      .concat([
        {
          dataKey: "mcp",
          name: "MCP",
          unit: "Rs/KWh",
          type: ChartType.Bar,
          yAxisId: "right",
        },
      ]);
  }

  function getSellerLegends() {
    return selectedSellers
      .flatMap((seller: any, index: number) =>
        chartSellerKeys.map(
          (key, chartIndex) => createChartObject(key, chartIndex, seller) as any
        )
      )
      .concat([
        {
          dataKey: "mcp",
          name: "MCP",
          unit: "Rs/KWh",
          type: ChartType.Bar,
          yAxisId: "right",
        },
      ]);
  }

  return (
    <>
      {loading && <Loading />}
      <PanelGroup className="" direction="horizontal">
        <Panel defaultSize={50} minSize={30} maxSize={70}>
          {/* Buyers Section */}
          <div className="bg-white rounded-xl overflow-hidden">
            {/* Header */}
            <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full bg-gray-500"></div>
                  <h4 className="text-base font-semibold text-gray-500">
                    Buyers Trend
                  </h4>
                </div>
                <SearchBox
                  options={availableEntities}
                  isMany={true}
                  placeholder="Search Buyers"
                  selectedOptions={selectedBuyers}
                  onChange={setSelectedBuyers}
                />
              </div>

              <div className="m-2 mx-0 p-4 bg-white rounded-xl">
                <ReMixChart
                  chartContainerHeight="calc(100vh - 370px)"
                  data={chartBuyerData}
                  showBrush={chartBuyerData.length > 96 ? true : undefined}
                  brushStart={BrushStart.Start}
                  isTimeSlot={false}
                  yAxisLabel={"MWh"}
                  secondYAxisLabel={"Rs/KWh"}
                  onlyTitle={true}
                  barCategoryGap={10}
                  legends={getBuyersLegends()}
                  hiddenLegends={["MCP"]}
                  xDataKey={"date"}
                />
              </div>
            </div>
          </div>
        </Panel>
        <PanelResizeHandle className="w-[1px] mx-5 bg-gray-200 h-[80%] my-auto relative">
          <div className="bg-white py-2 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <GripVertical color="#CDCDD3" />
          </div>
        </PanelResizeHandle>
        <Panel defaultSize={50} minSize={30} maxSize={80}>
          {" "}
          {/* Sellers Section */}
          <div className="bg-white rounded-xl overflow-hidden">
            <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full bg-[#34656D]"></div>
                  <h4 className="text-base font-semibold text-[#34656D]">
                    Sellers Trend
                  </h4>
                </div>
                <SearchBox
                  options={availableEntities}
                  isMany={true}
                  placeholder="Search Sellers"
                  selectedOptions={selectedSellers}
                  onChange={setSelectedSellers}
                />
              </div>

              <div className="m-2 mx-0 p-4 bg-white rounded-xl">
                <ReMixChart
                  chartContainerHeight="calc(100vh - 370px)"
                  data={chartSellerData}
                  showBrush={chartSellerData.length > 96 ? true : undefined}
                  brushStart={BrushStart.Start}
                  isTimeSlot={false}
                  yAxisLabel={"MWh"}
                  secondYAxisLabel={"Rs/KWh"}
                  onlyTitle={true}
                  barCategoryGap={10}
                  legends={getSellerLegends()}
                  hiddenLegends={["MCP"]}
                  xDataKey={"date"}
                />
              </div>
            </div>
          </div>
        </Panel>
      </PanelGroup>
    </>
  );
}
